import axios, { AxiosError } from 'axios';
import { API_BASE_URL } from '../constants';
import { authService } from './authService';
import { ROUTES } from '../constants';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Accept': 'application/json' },
  withCredentials: true,
});

// Добавляем Access-токен к каждому запросу
api.interceptors.request.use(
  (config) => {
    const token = authService.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// При 401 пробуем обновить токен и повторить запрос
api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as typeof error.config & { _retry?: boolean };

    if (error.response?.status === 401 && !originalRequest._retry) {
      const isAuthUrl =
        typeof originalRequest.url === 'string' &&
        (originalRequest.url.includes('/auth/login') || originalRequest.url.includes('/auth/refresh'));

      if (isAuthUrl) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      try {
        await authService.refresh();
        if (originalRequest.headers) {
          originalRequest.headers.Authorization = `Bearer ${authService.getAccessToken()}`;
        }
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh протух или ошибка — редирект на логин с сообщением «Сессия истекла»
        authService.logout(true);
        return Promise.reject(refreshError);
      }
    }

    if (error.response?.status === 401) {
      const path = window.location.pathname || '';
      if (!path.includes('/auth/login')) {
        window.location.href = `${window.location.origin}${ROUTES.LOGIN}`;
      }
    }

    return Promise.reject(error);
  }
);

export default api;
